/* eslint-disable @typescript-eslint/no-floating-promises */

'use client';

import { useEffect } from 'react';
import { useRouter, useSearchParams } from 'next/navigation';
import { CheckoutSkeleton } from 'components/ui/organisms/checkout/skeletons';
import { redirectToCheckout } from 'utils/redirect-to-checkout';
import { usePrepareCart } from 'frontastic/hooks';

export const AddToCartTastic = () => {
  const { prepareCartForCourses, prepareCartForProgram } = usePrepareCart();
  const searchParams = useSearchParams();
  const router = useRouter();
  const courseRunKeys = searchParams.getAll('course_run_key');
  const programId = searchParams.get('bundle');
  const discountCode = searchParams.get('code') ?? undefined;

  useEffect(() => {
    (async () => {
      if (programId) {
        await prepareCartForProgram(programId, discountCode);
        redirectToCheckout(router, { programId });
      } else if (courseRunKeys.length > 0) {
        await prepareCartForCourses(courseRunKeys, discountCode);
        redirectToCheckout(router);
      } else {
        redirectToCheckout(router);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <CheckoutSkeleton />;
};
